const Song = ({ song }) =>
{

  return (
    <div>
      Artist: {song.artist}<br />
      Title: {song.title}<br />
      {song.disk ? (
        <div>
          Disk {song.disk}
          <br />
        </div>)
        : ""
      }
      Track: {song.track}<br />
      Album: {song.album}
    </div>
  );
}

export default Song;
